import React from 'react';

import Pagination from 'components/Pagination';

const PopupAssignTherapistPagination = ({ options, onPageChange, loading, center }) => {
  return (
    <div className={'mt-2'}>
      <Pagination
        center={center}
        currentPage={options.page}
        totalPages={Math.ceil(options.total / options.page_size) ?? 0}
        onPageChange={onPageChange}
        loading={loading}
      />
    </div>
  );
};

export default React.memo(PopupAssignTherapistPagination);
